<template>
  <fieldset>
    <input-with-validation
        type="text"
        :label="label"
        v-model="customFieldValue"
        v-on:input="input">
    </input-with-validation>
  </fieldset>
</template>

<script>
  import { CustomField } from '../models/Booking'
  import inputWithValidation from './inputWithValidation'

  export default {
    name: 'customField',
    components: {
      inputWithValidation
    },
    props: [
      'value',
      'label'
    ],
    data () {
      return {
        customFieldValue: null,
        customFieldObject: null
      }
    },
    mounted () {
      this.customFieldObject = this.makeCustomFieldObject()
    },
    methods: {
      makeCustomFieldObject () {
        const customField = new CustomField()

        customField.label = this.label
        customField.value = this.value

        return customField
      },
      input () {
        this.customFieldObject.value = this.customFieldValue

        this.$emit('input', this.customFieldObject)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// customField.vue?30f62624